<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-btn @click="triggerDownload" color="primary" :loading="exoportLoading">Export </v-btn>
            <v-spacer></v-spacer>
            <v-col cols="6" md="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table :headers="headers" :items="records" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer :loading="loading">
              <template v-slot:[`item.createdAt`]="{ item }">
                {{ item.createdAt | formatdate }}
              </template>
          </v-data-table>
          <v-row>
            <v-col cols="12" md="3" class="text-right pt-6 caption"><span> {{ totalItemsInPage }} </span> out of <span class="font-weight-bold">{{ totalElements }} </span> Records </v-col>
            <v-col cols="12" md="5" class="text-left"> <v-pagination  v-model="page" :length="pageCount"> </v-pagination> </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
export default {
  name: 'ReferenceRecords',
  data: () => ({
    search: '',
    headers: [
      { text: 'Ref No', value: 'sessionChoice.refNo' },
      { text: 'Date Created', value: 'createdAt' },
      { text: 'Phone Number', value: 'chat.phoneNumber' },
      { text: 'Vehicle No', value: 'sessionChoice.stickerDetails.numberPlate' },
      { text: 'Status', value: 'sessionChoice.status' },
      { text: 'Sticker Ref', value: 'sessionChoice.stickerDetails.stickerReference' },
      { text: 'Check Response', value: 'sessionChoice.stickerDetails.stickerStatus' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    loading: false,
    exoportLoading: false,
    page: 1,
    itemsPerPage: 10,
    pageCount: 0,
    payload: { perPage: 10, page: 1 },
    records: [],
    totalElements: 0,
    totalItemsInPage: 0
  }),
  computed: mapState({
    referencerecords: state => state.botsession.referencerecords
  }),
  watch: {
    page () {
      this.payload.page = this.page
      this.triggerGetRecords()
    },
    search: function (query) {
      this.debouncedGetAnswer()
      this.page = 1
    }
  },
  methods: {
    ...mapActions({ downloadReferenceRecords: 'botsession/downloadReferenceRecords', getReferenceRecords: 'botsession/getReferenceRecords' }),
    triggerDownload () {
      this.loading = true
      this.downloadReferenceRecords().then(response => {
        this.loading = false
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Report.csv'
        link.click()
      }).catch(error => {
        this.loading = false
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    },
    triggerGetRecords () {
      this.loading = true
      this.records = []
      this.payload.search = this.search
      this.getReferenceRecords(this.payload).then(response => {
        this.records = response.data.data
        this.pageCount = response.data.totalPages
        this.totalElements = response.data.totalElements
        this.totalItemsInPage = response.data.totalItemsInPage
        this.loading = false
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
        this.loading = false
      })
    }
  },
  created () {
    this.triggerGetRecords()
    this.debouncedGetAnswer = _.debounce(this.triggerGetRecords, 1000)
  }
}
</script>
